<script lang="ts">
  import { Camas, Ingresos, Pacientes, type Cama, type Ingreso, type Paciente } from '../../../lib/api';

  let { limit = 8 }: { limit?: number } = $props();
  let rows = $state<{ ingreso: Ingreso; cama?: Cama; paciente?: Paciente }[]>([]);
  let error = $state<string | null>(null);

  async function cargar() {
    error = null;
    try {
      const [ingresos, camas, pacientes] = await Promise.all([
        Ingresos.activos(),
        Camas.list(),
        Pacientes.list(),
      ]);
      const camasById = new Map(camas.filter(c => c.id).map(c => [c.id!, c]));
      const pacById = new Map(pacientes.filter(p => p.id).map(p => [p.id!, p]));
      rows = ingresos.slice(0, limit).map(ingreso => ({
        ingreso,
        cama: camasById.get(ingreso.camaId),
        paciente: pacById.get(ingreso.pacienteId),
      }));
    } catch (e: any) {
      error = e?.message ?? String(e);
    }
  }

  $effect(() => {
    cargar();
    const t = setInterval(cargar, 30000);
    return () => clearInterval(t);
  });
</script>

<div class="panel">
  <header><h3>Ingresos activos</h3><button type="button" onclick={cargar}>↻</button></header>
  {#if error}<p class="err">{error}</p>{/if}
  {#if rows.length === 0 && !error}
    <p class="empty">Sin ingresos activos.</p>
  {:else}
    <ul>
      {#each rows as r (r.ingreso.id)}
        <li>
          <strong>{r.paciente ? `${r.paciente.nombres} ${r.paciente.apellidos}` : r.ingreso.pacienteId.slice(0, 8)}</strong>
          <span>Cama {r.cama?.numero ?? '—'} · {r.cama?.servicio ?? '—'}</span>
          {#if r.ingreso.diagnosticoIngreso}<em>{r.ingreso.diagnosticoIngreso}</em>{/if}
        </li>
      {/each}
    </ul>
  {/if}
</div>

<style>
  .panel { border: 1px solid var(--border); border-radius: var(--radius-md); background: var(--bg-elevated); overflow: hidden; }
  header { display: flex; justify-content: space-between; align-items: center; padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); }
  h3 { margin: 0; font-size: 0.9rem; color: var(--text-primary); }
  header button { border: 1px solid var(--border); background: var(--bg-surface); color: var(--text-secondary); border-radius: 6px; cursor: pointer; padding: 0.2rem 0.5rem; }
  ul { list-style: none; margin: 0; padding: 0; max-height: 280px; overflow: auto; }
  li { padding: 0.65rem 0.85rem; border-bottom: 1px solid var(--border); display: flex; flex-direction: column; gap: 0.15rem; }
  li strong { font-size: 0.88rem; color: var(--text-primary); }
  li span { font-size: 0.78rem; color: var(--text-secondary); }
  li em { font-size: 0.75rem; color: var(--brand-strong); font-style: normal; }
  .empty, .err { padding: 0.85rem; font-size: 0.85rem; margin: 0; }
  .err { color: var(--danger); }
  .empty { color: var(--text-secondary); }
</style>
